document.addEventListener("DOMContentLoaded", function () {
  // document.getElementById("product_loader").classList.add("loading");
  // **State object to manage selected values**
  const state = {
    width: 3,
    height: 3,
    materials: {},
    quantity_variable: 100,
    greater_dimension: 3,
    discounts: {},
  };

  // ========== UPSELL STATE & CONFIG ==========
  const UPSELL_DISCOUNT_PERCENT = 20; // Easy to change — just update this number
  const UPSELL_MATERIALS = [
    "Vinyl Stickers",
    "Matte Stickers",
    "Holographic Stickers",
    "Clear Stickers",
    "Heavy duty Stickers",
    "Reflective Stickers",
    "Prismatic Stickers",
    "Glitter Stickers",
    "Chrome/Mirror Stickers",
    "Gold Mirror Stickers",
    "Gold Brushed Stickers",
    "Gold Glitter Stickers",
  ];

  const UPSELL_MATERIAL_DISPLAY_NAMES = {
    "Vinyl Stickers": "Vinyl",
    "Matte Stickers": "Matte",
    "Holographic Stickers": "Holographic",
    "Clear Stickers": "Clear",
    "Heavy duty Stickers": "Heavy Duty",
    "Reflective Stickers": "Reflective",
    "Prismatic Stickers": "Prismatic",
    "Glitter Stickers": "Glitter",
    "Chrome/Mirror Stickers": "Chrome Mirror",
    "Gold Mirror Stickers": "Gold Mirror",
    "Gold Brushed Stickers": "Gold Brushed",
    "Gold Glitter Stickers": "Gold Glitter",
  };

  /** Per-material swatch art (modified custom stickers — picker + upsell) */
  const PCS_MATERIAL_SWATCH_URLS = {
    "Vinyl Stickers":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/Vinyl.webp?v=1776710235",
    "Matte Stickers":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/Matte.webp?v=1776710235",
    "Holographic Stickers":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/Holographic.webp?v=1776710235",
    "Clear Stickers":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/Clear.webp?v=1776710235",
    "Heavy duty Stickers":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/Heavy_Duty.webp?v=1776710235",
    "Reflective Stickers":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/Reflective.webp?v=1776710235",
    "Prismatic Stickers":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/Prismatic.webp?v=1776710235",
    "Glitter Stickers":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/Glitter.webp?v=1776710236",
    "Chrome/Mirror Stickers":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/Chrome_Mirror.webp?v=1776710235",
    "Gold Mirror Stickers":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/Gold_Mirror.webp?v=1776710236",
    "Gold Brushed Stickers":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/Gold_Brushed.webp?v=1776710235",
    "Gold Glitter Stickers":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/Gold_Glitter.webp?v=1776710236",
  };

  function pcsApplyMaterialPickerSwatches() {
    document
      .querySelectorAll("#material-variant .pcs-mat-card[data-material]")
      .forEach((card) => {
        const url = PCS_MATERIAL_SWATCH_URLS[card.dataset.material];
        const img = card.querySelector(".pcs-mat-card__swatch");
        if (img && url) img.src = url;
      });
  }

  // Track upsell items the user has added
  const upsellCart = []; // Array of { material, quantity, price, originalPrice }

  /* ===== Quantity options — multiples of 5 only ===== */
  function getUpsellQuantityOptions(primaryQty) {
    const opts = new Set();
    const primary = Math.round(primaryQty / 5) * 5;
    if (primary >= 10) opts.add(primary);
    let current = primary;
    for (let i = 0; i < 2; i++) {
      current = Math.round((current / 2) / 5) * 5;
      if (current >= 10) opts.add(current);
    }
    const sorted = [...opts].sort((a, b) => b - a); // descending: highest first
    return sorted.length > 0 ? sorted : [10];
  }




  // ========== UPSELL: CALCULATE PRICE FOR A MATERIAL ADD-ON ==========
  function calculateUpsellPrice(material, quantity) {
    const size = state.width * state.height;
    const materialPrice = state.materials[material] || 0;
    const adjustedQuantity = calculateDiscount(quantity);
    const greaterDim = state.greater_dimension;

    const discount =
      state.discounts?.[material]?.[greaterDim]?.[adjustedQuantity] ?? 0;
    const discountMultiplier = (100 - discount) / 100;

    let fullPrice = size * quantity * materialPrice * discountMultiplier;
    if (fullPrice < 25) fullPrice = 25;

    const upsellDiscountMultiplier = (100 - UPSELL_DISCOUNT_PERCENT) / 100;
    let discountedPrice = fullPrice * upsellDiscountMultiplier;

    return {
      original: fullPrice,
      discounted: discountedPrice,
    };
  }

  function upsellAddedButtonInnerHTML() {
    return (
      '<span class="upsell-add-btn-label upsell-add-btn-label--default">\u2713 Added</span>' +
      '<span class="upsell-add-btn-label upsell-add-btn-label--hover">' +
      '<span class="upsell-remove-icon" aria-hidden="true">\u2715</span> Remove</span>'
    );
  }

  function setUpsellAddButtonState(btn, isAdded) {
    if (!btn) return;
    if (isAdded) {
      btn.classList.add("added");
      btn.innerHTML = upsellAddedButtonInnerHTML();
      btn.setAttribute("aria-label", "Remove material add-on");
    } else {
      btn.classList.remove("added");
      btn.textContent = "+ Add";
      btn.removeAttribute("aria-label");
    }
  }

  function placeUpsellBlock(preferUploadMount) {
    const upsellBlock = document.getElementById("upsell-block");
    const mountUpload = document.getElementById("upsell-mount-upload");
    const mountDefault = document.getElementById("upsell-mount-default");
    if (!upsellBlock || !mountUpload || !mountDefault) return;
    const target = preferUploadMount ? mountUpload : mountDefault;
    if (upsellBlock.parentElement !== target) {
      target.appendChild(upsellBlock);
    }
  }

  function placeCheckoutButton(preferUploadMount) {
    const btn = document.getElementById("pcs-add-to-cart");
    const mountUpload = document.getElementById("pcs-checkout-mount-upload");
    const mountDefault = document.getElementById("pcs-checkout-mount-default");
    if (!btn || !mountUpload || !mountDefault) return;
    const target = preferUploadMount ? mountUpload : mountDefault;
    if (btn.parentElement !== target) {
      target.appendChild(btn);
    }
  }

  function placeCheckoutSummary() {
    const summary = document.getElementById("pcs-checkout-summary");
    const btn = document.getElementById("pcs-add-to-cart");
    const mountUpload = document.getElementById("pcs-checkout-summary-mount-upload");
    const mountEmail = document.getElementById("pcs-checkout-summary-mount-email");
    const mountDefault = document.getElementById("pcs-checkout-mount-default");
    if (!summary || !btn || !mountUpload || !mountEmail || !mountDefault) return;

    const hasFile = artworkHasUploadedFile();
    const willEmail = !!document.getElementById("email-later")?.checked;

    if (hasFile) {
      if (summary.parentElement !== mountUpload) {
        mountUpload.appendChild(summary);
      }
    } else if (willEmail) {
      if (summary.parentElement !== mountEmail) {
        mountEmail.appendChild(summary);
      }
    } else {
      mountDefault.insertBefore(summary, btn);
    }
  }

  function artworkHasUploadedFile() {
    const fileInput = document.querySelector(".calc-prop.cpc-file-upload");
    return !!(fileInput && fileInput.files && fileInput.files.length > 0);
  }

  // ========== UPSELL: BUILD THE MATERIAL CARDS ==========
  function renderUpsellCards() {
    const grid = document.getElementById('upsell-materials-grid');
    if (!grid) return;

    const primaryMaterial =
      document.querySelector("#material-variant .pcs-mat-card--selected")
        ?.dataset.material || "Vinyl Stickers";
    const primaryQty = state.quantity_variable || 100;
    const qtyOptions = getUpsellQuantityOptions(primaryQty);

    grid.innerHTML = '';

    const materialsToShow = UPSELL_MATERIALS.filter(m => m !== primaryMaterial);

    materialsToShow.forEach(material => {
      const defaultQty = qtyOptions[0]; // highest option selected by default
      const prices = calculateUpsellPrice(material, defaultQty);
      const displayName = UPSELL_MATERIAL_DISPLAY_NAMES[material] || material;
      const swatchUrl =
        PCS_MATERIAL_SWATCH_URLS[material] ||
        PCS_MATERIAL_SWATCH_URLS["Vinyl Stickers"];
      const existingItem = upsellCart.find(i => i.material === material);
      const currentQty = existingItem ? existingItem.quantity : defaultQty;
      const currentPrices = calculateUpsellPrice(material, currentQty);

      const card = document.createElement('div');
      card.className = `upsell-material-card${existingItem ? ' added' : ''}`;
      card.dataset.material = material;

      // Build <option> tags
      const optionsHTML = qtyOptions
        .map(q => {
          const selected = q === currentQty ? ' selected' : '';
          return `<option value="${q}"${selected}>${q} pcs</option>`;
        })
        .join('');

      const popularBadgeHtml =
        material === "Holographic Stickers"
          ? `<span class="upsell-mat-badge upsell-mat-badge--popular" aria-hidden="true"><span class="upsell-mat-badge__star">★</span> Most Popular</span>`
          : "";
      const bodyClass =
        material === "Holographic Stickers"
          ? "upsell-card-body upsell-card-body--has-badge"
          : "upsell-card-body";

      card.innerHTML = `
          <div class="upsell-card-media">
              <div class="upsell-swatch-wrapper">
                  <img src="${swatchUrl}"
                       class="upsell-swatch" alt="" />
              </div>
          </div>
          <div class="${bodyClass}">
              ${popularBadgeHtml}
              <div class="upsell-card-title-row">
                  <p class="upsell-mat-name">${displayName}</p>
              </div>
              <div class="upsell-price-row">
                  <span class="upsell-price-discounted">$${currentPrices.discounted.toFixed(2)}</span>
                  <span class="upsell-price-original">$${currentPrices.original.toFixed(2)}</span>
              </div>
          </div>
          <div class="upsell-card-actions">
              <select class="upsell-qty-select" data-material="${material}">
                  ${optionsHTML}
              </select>
              <button type="button" class="upsell-add-btn${existingItem ? ' added' : ''}" data-material="${material}">
                  ${existingItem ? upsellAddedButtonInnerHTML() : "+ Add"}
              </button>
          </div>
      `;

      grid.appendChild(card);
    });

    attachUpsellCardEvents();
  }


  /* ===== Helper: update price on card when qty changes ===== */
  function updateCardPrice(material, qty) {
    const card = document.querySelector(
      `.upsell-material-card[data-material="${material}"]`
    );
    if (!card) return;
    const prices = calculateUpsellPrice(material, qty);
    card.querySelector('.upsell-price-discounted').textContent =
      '$' + prices.discounted.toFixed(2);
    card.querySelector('.upsell-price-original').textContent =
      '$' + prices.original.toFixed(2);
  }




  // ========== UPSELL: EVENT LISTENERS FOR CARDS ==========
  function attachUpsellCardEvents() {
    // Quantity dropdown change → update price on card + cart if already added
    document.querySelectorAll('.upsell-qty-select').forEach(select => {
      select.addEventListener('change', function (e) {
        e.stopPropagation();
        const mat = this.dataset.material;
        const qty = parseInt(this.value);

        // Update price display on card
        updateCardPrice(mat, qty);

        // If already in upsell cart, update that entry
        const cartItem = upsellCart.find(i => i.material === mat);
        if (cartItem) {
          cartItem.quantity = qty;
          const prices = calculateUpsellPrice(mat, qty);
          cartItem.price = prices.discounted;
          cartItem.originalPrice = prices.original;
          renderUpsellChips();
          updateUpsellSummary();
        }
      });
    });

    // Add / remove button
    document.querySelectorAll('.upsell-add-btn').forEach(btn => {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        const mat = this.dataset.material;
        const card = this.closest('.upsell-material-card');
        const select = card.querySelector('.upsell-qty-select');
        const qty = parseInt(select.value);

        const existingIndex = upsellCart.findIndex(i => i.material === mat);

        if (existingIndex > -1) {
          // Remove
          upsellCart.splice(existingIndex, 1);
          setUpsellAddButtonState(this, false);
          card.classList.remove('added');
        } else {
          // Add
          const prices = calculateUpsellPrice(mat, qty);
          upsellCart.push({
            material: mat,
            displayName: UPSELL_MATERIAL_DISPLAY_NAMES[mat] || mat,
            quantity: qty,
            price: prices.discounted,
            originalPrice: prices.original
          });
          setUpsellAddButtonState(this, true);
          card.classList.add('added');

          // 🎉 Fire confetti from this button
          fireUpsellConfetti(this);
        }

        renderUpsellChips();
        updateUpsellSummary();
      });
    });
  }


  /* ===== Mini Confetti Burst — fires from the clicked button ===== */
  function fireUpsellConfetti(buttonEl) {
    const rect = buttonEl.getBoundingClientRect();
    const originX = rect.left + rect.width / 2;
    const originY = rect.top + rect.height / 2;

    const colors = ['#59c8e6', '#1a1a1a', '#ffd700', '#ff6b6b', '#48d1a0', '#a78bfa'];
    const shapes = ['circle', 'square'];
    const count = 18;

    for (let i = 0; i < count; i++) {
      const particle = document.createElement('div');
      const size = Math.random() * 6 + 4;
      const isCircle = shapes[Math.floor(Math.random() * shapes.length)] === 'circle';
      const color = colors[Math.floor(Math.random() * colors.length)];
      const angle = (Math.PI * 2 * i) / count + (Math.random() - 0.5) * 0.5;
      const velocity = Math.random() * 60 + 40;
      const dx = Math.cos(angle) * velocity;
      const dy = Math.sin(angle) * velocity - 20; // bias upward

      Object.assign(particle.style, {
        position: 'fixed',
        left: originX + 'px',
        top: originY + 'px',
        width: size + 'px',
        height: size + 'px',
        borderRadius: isCircle ? '50%' : '2px',
        background: color,
        pointerEvents: 'none',
        zIndex: '99999',
        opacity: '1',
        transform: 'translate(-50%, -50%) rotate(0deg)',
        transition: 'none',
      });

      document.body.appendChild(particle);

      // Animate with requestAnimationFrame
      const startTime = performance.now();
      const duration = 600 + Math.random() * 300;
      const rotEnd = (Math.random() - 0.5) * 720;

      function animate(now) {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const ease = 1 - Math.pow(1 - progress, 3); // ease-out cubic
        const gravity = progress * progress * 80; // gravity pull

        const x = originX + dx * ease;
        const y = originY + dy * ease + gravity;
        const rot = rotEnd * ease;
        const opacity = progress < 0.7 ? 1 : 1 - ((progress - 0.7) / 0.3);

        particle.style.left = x + 'px';
        particle.style.top = y + 'px';
        particle.style.opacity = opacity;
        particle.style.transform = `translate(-50%, -50%) rotate(${rot}deg)`;

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          particle.remove();
        }
      }

      requestAnimationFrame(animate);
    }
  }



  // ========== UPSELL: RENDER CONFIRMATION CHIPS ==========
  function renderUpsellChips() {
    const container = document.getElementById("upsell-added-items");
    if (!container) return;

    container.innerHTML = "";

    upsellCart.forEach((item, index) => {
      const displayName =
        UPSELL_MATERIAL_DISPLAY_NAMES[item.material] || item.material;

      const chip = document.createElement("div");
      chip.className = "upsell-chip";
      chip.innerHTML = `
    <span class="upsell-chip-info">🛒 ${displayName} (${item.quantity} pcs, ${state.width}"×${state.height}")</span>
    <span class="upsell-chip-price">$${item.price.toFixed(2)}</span>
    <button class="upsell-chip-remove" data-index="${index}" data-material="${item.material}" title="Remove">✕</button>
  `;

      container.appendChild(chip);
    });

    // Attach remove listeners
    container.querySelectorAll(".upsell-chip-remove").forEach((btn) => {
      btn.addEventListener("click", function () {
        const index = parseInt(this.dataset.index);
        const material = this.dataset.material;

        // Remove from upsell cart
        upsellCart.splice(index, 1);

        // Reset the card UI
        const card = document.querySelector(
          `.upsell-material-card[data-material="${material}"]`
        );
        if (card) {
          card.classList.remove("added");
          const addBtn = card.querySelector(".upsell-add-btn");
          if (addBtn) {
            setUpsellAddButtonState(addBtn, false);
          }
        }

        renderUpsellChips();
        updateUpsellSummary();
      });
    });
  }

  // ========== UPSELL: UPDATE ORDER SUMMARY ==========
  function updateUpsellSummary() {
    const summary = document.getElementById('upsell-order-summary');
    const savedAmountEl = document.getElementById('upsell-total-saved-amount');

    if (upsellCart.length === 0) {
      if (summary) summary.style.display = 'none';
      if (savedAmountEl) savedAmountEl.innerHTML = '<b>$0.00</b>';
      updateCheckoutOrderSummary();
      return;
    }

    if (summary) summary.style.display = '';

    let totalSaved = 0;
    upsellCart.forEach(item => {
      totalSaved += (item.originalPrice - item.price);
    });

    if (savedAmountEl) {
      savedAmountEl.innerHTML = `<b>$${totalSaved.toFixed(2)}</b>`;
    }
    updateCheckoutOrderSummary();
  }

  // ========== Checkout recap (primary + upsell lines + order total) ==========
  function updateCheckoutOrderSummary(overridePrimaryPrice) {
    const wrap = document.getElementById("pcs-checkout-summary");
    const btn = document.getElementById("pcs-add-to-cart");
    if (!wrap) return;

    if (!btn || btn.disabled) {
      wrap.style.display = "none";
      return;
    }

    const primaryLabelEl = document.getElementById("pcs-summary-primary-label");
    const primaryPriceEl = document.getElementById("pcs-summary-primary-price");
    const addonContainer = document.getElementById("pcs-summary-addon-rows");
    const totalEl = document.getElementById("pcs-summary-order-total");
    if (!primaryLabelEl || !primaryPriceEl || !addonContainer || !totalEl) return;

    const primaryMaterial =
      document.querySelector("#material-variant .pcs-mat-card--selected")
        ?.dataset.material ||
      document.getElementById("material-artwork")?.textContent?.trim() ||
      "Custom stickers";
    const qty = state.quantity_variable || 0;
    const primaryPrice =
      overridePrimaryPrice !== undefined && overridePrimaryPrice !== null
        ? Number(overridePrimaryPrice)
        : parseFloat(document.getElementById("price-artwork")?.textContent) || 0;

    wrap.style.display = "block";
    primaryLabelEl.textContent = `${primaryMaterial} (${qty} pcs)`;
    primaryPriceEl.textContent = `$${primaryPrice.toFixed(2)}`;

    addonContainer.innerHTML = "";
    let upsellSum = 0;
    upsellCart.forEach((item) => {
      upsellSum += item.price;
      const row = document.createElement("div");
      row.className =
        "pcs-checkout-summary__row pcs-checkout-summary__row--addon";
      row.innerHTML = `<span class="pcs-checkout-summary__label">+ ${item.displayName} (${item.quantity} pcs, ${UPSELL_DISCOUNT_PERCENT}% off)</span><span class="pcs-checkout-summary__price">$${item.price.toFixed(2)}</span>`;
      addonContainer.appendChild(row);
    });

    const total = primaryPrice + upsellSum;
    totalEl.textContent = `$${total.toFixed(2)}`;

    const divider = wrap.querySelector(".pcs-checkout-summary__divider");
    if (divider) {
      divider.style.display = "";
    }
  }

  // ========== UPSELL: SHOW/HIDE BASED ON FILE UPLOAD OR EMAIL LATER ==========
  function showUpsellBlock() {
    const upsellBlock = document.getElementById("upsell-block");
    if (!upsellBlock) return;

    const hasFile = artworkHasUploadedFile();
    const emailLater = document.getElementById("email-later");
    const willEmail = emailLater && emailLater.checked;

    // Upload path: upsell above design-proof checkbox; email path: default slot under .content
    placeUpsellBlock(hasFile);
    placeCheckoutButton(hasFile);
    placeCheckoutSummary();

    if (hasFile || willEmail) {
      upsellBlock.style.display = "block";
      renderUpsellCards();
      updateUpsellSummary();
    } else {
      upsellBlock.style.display = "none";
      placeCheckoutButton(false);
      placeCheckoutSummary();
      updateCheckoutOrderSummary();
    }
  }

  // ========== UPSELL: HOOK INTO FILE UPLOAD & EMAIL LATER EVENTS ==========
  function setupUpsellTriggers() {
    const fileInput = document.querySelector(".calc-prop.cpc-file-upload");
    const emailLater = document.getElementById("email-later");

    if (fileInput) {
      // We need to add our listener AFTER the existing one
      // Use a MutationObserver on file-path display to detect file selection
      const filePathEl = document.getElementById("file-path");
      if (filePathEl) {
        const fileObserver = new MutationObserver(() => {
          setTimeout(showUpsellBlock, 100);
        });
        fileObserver.observe(filePathEl, {
          attributes: true,
          attributeFilter: ["style"],
        });
      }

      // Also listen to change event directly
      fileInput.addEventListener("change", () => {
        setTimeout(showUpsellBlock, 100);
      });
    }

    if (emailLater) {
      emailLater.addEventListener("change", () => {
        setTimeout(showUpsellBlock, 100);
      });
    }
  }


  // **Fetch the JSON file using the URL stored in the global variable** //
  fetch(window.printCustomStickersDiscount)
    .then((response) => response.json())
    .then((data) => {
      state.discounts = data;
      pcsTryInitQuantityTiers();
    })
    .catch((error) => console.error("Error loading JSON:", error));

  // **Materials Data**
  fetch(window.printCustomStickersMaterials)
    .then((response) => response.json())
    .then((data) => {
      state.materials = data;
      pcsTryInitQuantityTiers();
    })
    .catch((error) => console.error("Error loading JSON:", error));

  // **Function to determine greater dimension for discounts**
  function greaterDimension(w, h) {
    const rw = Math.round(w);
    const rh = Math.round(h);
    return Math.min(Math.max(rw, rh), 8);
  }

  function animatePriceChange(targetElement, start, end, duration = 500) {
    let startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const currentValue = start + (end - start) * progress;

      targetElement.textContent = currentValue.toFixed(2);

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  function calculateDiscount(quantity) {
    if (quantity < 10) {
      return 10;
    }

    // Adjust the quantity to the nearest discount tier
    if (quantity >= 10 && quantity < 50) {
      return 10;
    } else if (quantity >= 50 && quantity < 100) {
      return 50;
    } else if (quantity >= 100 && quantity < 200) {
      return 100;
    } else if (quantity >= 200 && quantity < 300) {
      return 200;
    } else if (quantity >= 300 && quantity < 500) {
      return 300;
    } else if (quantity >= 500 && quantity < 800) {
      return 500;
    } else if (quantity >= 800 && quantity < 1000) {
      return 800;
    } else if (quantity >= 1000 && quantity < 1500) {
      return 1000;
    } else if (quantity >= 1500 && quantity < 2000) {
      return 1500;
    } else if (quantity >= 2000 && quantity < 5000) {
      return 2000;
    } else {
      return 5000;
    }
  }

  const PCS_QUANTITY_TIER_VALUES = [
    50, 100, 200, 300, 500, 800, 1000, 1500, 2000, 5000,
  ];
  const PCS_QTY_TIER_POPULAR = 100;
  const PCS_QTY_TIER_BEST_VALUE = 500;
  const PCS_QTY_TIER_ECONOMICAL = 5000;

  const PCS_QUANTITY_SOCIAL_PROOF_MESSAGES = [
    "92% of customers order 200 pcs or more",
    "Higher qty means a lower price per piece.",
    "Most repeat orders are 500 pcs or up.",
    "Scale your run—save more per unit.",
  ];

  let pcsQuantitySocialProofTimerId = null;

  function pcsStartQuantitySocialProofRotation() {
    const el = document.querySelector(".pcs-quantity-social-proof__text");
    if (!el) return;
    if (pcsQuantitySocialProofTimerId != null) {
      window.clearInterval(pcsQuantitySocialProofTimerId);
      pcsQuantitySocialProofTimerId = null;
    }
    const messages = PCS_QUANTITY_SOCIAL_PROOF_MESSAGES;
    let i = 0;
    el.textContent = messages[i];
    pcsQuantitySocialProofTimerId = window.setInterval(() => {
      i = (i + 1) % messages.length;
      el.textContent = messages[i];
    }, 3500);
  }

  function pcsGetQuantityTierPricing(qty, material, greaterDim) {
    const size = (state.width || 0) * (state.height || 0);
    const matPrice = state.materials[material] || 0;
    const adj = calculateDiscount(qty);
    const disc =
      state.discounts?.[material]?.[greaterDim]?.[adj] ?? 0;
    const mult = (100 - disc) / 100;
    let total = size * qty * matPrice * mult;
    if (total < 25) total = 25;
    const unit = qty > 0 ? total / qty : 0;
    return { total, unit, discountPct: disc };
  }

  function pcsSyncQuantityTierSelectedClasses() {
    const list = document.getElementById("pcs-quantity-tier-list");
    if (!list) return;
    list.querySelectorAll(".pcs-qty-tier").forEach((label) => {
      const radio = label.querySelector(".pcs-qty-tier__radio");
      label.classList.toggle("pcs-qty-tier--selected", !!radio?.checked);
    });
  }

  function pcsBuildQuantityTierList() {
    const host = document.getElementById("pcs-quantity-tier-list");
    if (!host) return;

    const material =
      document.querySelector("#material-variant .pcs-mat-card--selected")
        ?.dataset.material || "Vinyl Stickers";
    const gd = state.greater_dimension;
    const customInputVal =
      document.getElementById("custom-quantity")?.value?.trim() || "";
    const activePreset = customInputVal
      ? null
      : PCS_QUANTITY_TIER_VALUES.includes(state.quantity_variable)
        ? state.quantity_variable
        : 100;

    let html = "";
    for (const qty of PCS_QUANTITY_TIER_VALUES) {
      const { total, unit, discountPct } = pcsGetQuantityTierPricing(
        qty,
        material,
        gd
      );
      const badges = [];
      if (qty === PCS_QTY_TIER_POPULAR) {
        badges.push(
          `<span class="pcs-qty-badge pcs-qty-badge--popular">Most Popular</span>`
        );
      }
      if (qty === PCS_QTY_TIER_BEST_VALUE) {
        badges.push(
          `<span class="pcs-qty-badge pcs-qty-badge--value"><span class="pcs-qty-badge__star" aria-hidden="true">★</span> Best Value</span>`
        );
      }
      if (qty === PCS_QTY_TIER_ECONOMICAL) {
        badges.push(
          `<span class="pcs-qty-badge pcs-qty-badge--economical">Economical</span>`
        );
      }
      const saveHtml =
        discountPct > 0
          ? `<span class="pcs-qty-tier__save">Save ${discountPct}%</span>`
          : `<span class="pcs-qty-tier__save pcs-qty-tier__save--empty">\u00a0</span>`;
      const highlightClass =
        qty === PCS_QTY_TIER_BEST_VALUE ? " pcs-qty-tier--highlight" : "";
      const checked =
        activePreset !== null && qty === activePreset ? " checked" : "";
      html += `<label class="pcs-qty-tier${highlightClass}" data-qty="${qty}">
      <input type="radio" name="quantity-tier" value="${qty}" class="pcs-qty-tier__radio"${checked} />
      <span class="pcs-qty-tier__inner">
        <span class="pcs-qty-tier__qty">${qty} pcs</span>
        <span class="pcs-qty-tier__unit">$${unit.toFixed(2)}/ea</span>
        <span class="pcs-qty-tier__mid">${badges.join("")}${saveHtml}</span>
        <span class="pcs-qty-tier__total">$${total.toFixed(2)}</span>
      </span>
    </label>`;
    }

    html += `<label class="pcs-qty-tier pcs-qty-tier--custom" data-qty="custom">
      <input type="radio" name="quantity-tier" value="custom" class="pcs-qty-tier__radio" />
      <span class="pcs-qty-tier__inner pcs-qty-tier__inner--custom">
        <span class="pcs-qty-tier__custom-row">
          <span class="pcs-qty-tier__qty">Custom Quantity</span>
          <span class="pcs-qty-tier__custom-hint">Enter any amount</span>
        </span>
      </span>
    </label>`;

    host.innerHTML = html;

    if (customInputVal) {
      const cr = host.querySelector('input[name="quantity-tier"][value="custom"]');
      if (cr) {
        cr.checked = true;
        host.querySelectorAll('input[name="quantity-tier"]').forEach((r) => {
          if (r !== cr) r.checked = false;
        });
      }
    } else {
      const q = activePreset ?? 100;
      const pr = host.querySelector(
        `input[name="quantity-tier"][value="${q}"]`
      );
      if (pr) pr.checked = true;
    }
    pcsSyncQuantityTierSelectedClasses();
  }

  function pcsRefreshQuantityTierPricingOnly() {
    const host = document.getElementById("pcs-quantity-tier-list");
    if (!host || !host.querySelector(".pcs-qty-tier")) {
      if (
        state.materials &&
        Object.keys(state.materials).length > 0 &&
        state.discounts &&
        Object.keys(state.discounts).length > 0
      ) {
        pcsBuildQuantityTierList();
      }
      return;
    }
    const material =
      document.querySelector("#material-variant .pcs-mat-card--selected")
        ?.dataset.material || "Vinyl Stickers";
    const gd = state.greater_dimension;
    host.querySelectorAll(".pcs-qty-tier[data-qty]").forEach((label) => {
      const raw = label.dataset.qty;
      if (raw === "custom") return;
      const qty = parseInt(raw, 10);
      const { total, unit, discountPct } = pcsGetQuantityTierPricing(
        qty,
        material,
        gd
      );
      const unitEl = label.querySelector(".pcs-qty-tier__unit");
      const totalEl = label.querySelector(".pcs-qty-tier__total");
      const saveEl = label.querySelector(".pcs-qty-tier__save");
      if (unitEl && !unitEl.classList.contains("pcs-qty-tier__unit--muted")) {
        unitEl.textContent = `$${unit.toFixed(2)}/ea`;
      }
      if (totalEl && !totalEl.classList.contains("pcs-qty-tier__total--muted")) {
        totalEl.textContent = `$${total.toFixed(2)}`;
      }
      if (saveEl) {
        if (discountPct > 0) {
          saveEl.textContent = `Save ${discountPct}%`;
          saveEl.classList.remove("pcs-qty-tier__save--empty");
        } else {
          saveEl.textContent = "\u00a0";
          saveEl.classList.add("pcs-qty-tier__save--empty");
        }
      }
    });
  }

  function pcsRefreshMaterialGridPrices() {
    const grid = document.querySelector("#material-variant .pcs-mat-grid");
    if (
      !grid ||
      !state.materials ||
      Object.keys(state.materials).length === 0
    ) {
      return;
    }
    const gd = state.greater_dimension;
    let qty = state.quantity_variable;
    if (qty == null || !Number.isFinite(Number(qty)) || Number(qty) < 1) {
      qty = 100;
    }
    grid.querySelectorAll(".pcs-mat-card[data-material]").forEach((card) => {
      const m = card.dataset.material;
      if (!m) return;
      const { unit } = pcsGetQuantityTierPricing(qty, m, gd);
      const el = card.querySelector(".pcs-mat-card__price-val");
      if (el) el.textContent = unit.toFixed(2);
    });
  }

  function pcsTryInitQuantityTiers() {
    if (!document.getElementById("pcs-quantity-tier-list")) return;
    if (
      !state.materials ||
      Object.keys(state.materials).length === 0 ||
      !state.discounts ||
      Object.keys(state.discounts).length === 0
    ) {
      return;
    }
    if (!document.querySelector("#pcs-quantity-tier-list .pcs-qty-tier")) {
      pcsBuildQuantityTierList();
      if (document.querySelector("#calculator")) {
        updateCalculator();
      }
    } else {
      pcsRefreshQuantityTierPricingOnly();
      pcsRefreshMaterialGridPrices();
    }
  }

  function calculatePrice(s, q, m, d) {
    const materialPrice = state.materials[m] || 0;

    if (!materialPrice) {
      console.warn(`⚠️ Material type "${m}" not found! Defaulting to 0.`);
    }

    // **Calculate the final price**
    let finalPrice = s * q * materialPrice * d;
    let noDiscountPrice = s * q * materialPrice;

    if (finalPrice < 25) {
      finalPrice = 25;
    }

    // **Get the target price element**
    const priceElement = document.querySelector("#pcs-final-price");
    const cutoffPriceElement = document.querySelector("#pcs-cutoff-price");
    const cutoffPriceBlock = document.querySelector(
      ".pcs-price__ticker.cutoff-price"
    );
    const artworkPriceElement = document.querySelector("#price-artwork");

    if (cutoffPriceElement) {
      if (d === 1) {
        cutoffPriceBlock.style.display = "none";
      } else if (d < 1) {
        cutoffPriceBlock.style.display = "block";
        const currentPrice = parseFloat(cutoffPriceElement.textContent) || 0;
        animatePriceChange(cutoffPriceElement, currentPrice, noDiscountPrice);
      }
    }

    if (priceElement) {
      const currentPrice = parseFloat(priceElement.textContent) || 0;

      // **Apply counter effect**
      animatePriceChange(priceElement, currentPrice, finalPrice);
    }

    if (artworkPriceElement)
      animatePriceChange(
        artworkPriceElement,
        parseFloat(artworkPriceElement.textContent) || 0,
        finalPrice
      );

    updateCheckoutOrderSummary(finalPrice);
  }

  // **Function to safely update calculator values**
  function updateCalculator() {
    const calculator = document.querySelector("#calculator");
    if (!calculator) return;

    const cutlineTextarea = calculator.querySelector(
      "textarea[name='properties[Cutline]']"
    );
    const defaultShape =
      document.querySelector(".sticker-variant.active")?.dataset.shape ||
      "Contour-Cut";

    if (cutlineTextarea) {
      cutlineTextarea.value = defaultShape;
    }

    const fileInput = document.querySelector(".calc-prop.cpc-file-upload");

    if (fileInput) {
      fileInput.setAttribute(
        "accept",
        ".ai,.eps,.jpg,.jpeg,.png,.pdf,.tiff,.svg"
      );
    }

    // **Get selected material type**
    const selectedMaterial =
      document.querySelector("#material-variant .pcs-mat-card--selected")
        ?.dataset.material || "Vinyl Stickers";

    const adjustedQuantity = calculateDiscount(state.quantity_variable);
    const discount =
      state.discounts?.[selectedMaterial]?.[state.greater_dimension]?.[
      adjustedQuantity
      ] ?? 0;
    const discountMultiplier = (100 - discount) / 100;

    const quantity = state.quantity_variable || 0;
    const size = state.width && state.height ? state.width * state.height : 0;

    // **Update form values**
    calculator.querySelector("input[name='properties[Discount]']").value =
      discountMultiplier;
    const qtyField =
      document.getElementById("pcs-quantity-hidden") ||
      calculator.querySelector("[name='properties[Quantity]']");
    if (qtyField) qtyField.value = quantity;
    calculator.querySelector("input[name='properties[Width]']").value =
      state.width || "";
    calculator.querySelector("input[name='properties[Height]']").value =
      state.height || "";

    // **Update Artwork Details**
    document.querySelector("#shape-artwork").textContent =
      calculator.querySelector("textarea[name='properties[Cutline]']").value;
    document.querySelector("#width-artwork").textContent = state.width || "0";
    document.querySelector("#height-artwork").textContent = state.height || "0";
    document.querySelector("#quantity-artwork").textContent = quantity || "0";
    document.querySelector("#material-artwork").textContent = selectedMaterial;

    // **Call calculatePrice() with material pricing**
    calculatePrice(size, quantity, selectedMaterial, discountMultiplier);
    safePriceUpdation();
    pcsRefreshQuantityTierPricingOnly();
    pcsRefreshMaterialGridPrices();
  }

  // **Ensures priceUpdation() runs when available**
  function safePriceUpdation() {
    if (typeof window.PriceUpdation === "function") {
      window.PriceUpdation();
    } else {
      console.warn("⚠️ PriceUpdation function not available. Retrying...");
      let retry = setInterval(() => {
        if (typeof window.PriceUpdation === "function") {
          clearInterval(retry);
          console.log("✅ PriceUpdation function found. Executing...");
          window.PriceUpdation();
        }
      }, 500);
    }
  }

  // **Event Listener: Shape Selection**
  function setupShapeSelection() {
    document.addEventListener("click", function (event) {
      const selectedVariant = event.target.closest(
        "#shape-variant .sticker-variant"
      );

      if (selectedVariant) {
        // Remove active class only from shape variants
        document
          .querySelectorAll("#shape-variant .sticker-variant")
          .forEach((el) => el.classList.remove("active"));

        selectedVariant.classList.add("active");

        const calculator = document.querySelector("#calculator");
        const shapeArtwork = document.querySelector("#shape-artwork");
        if (calculator) {
          const cutlineTextarea = calculator.querySelector(
            "textarea[name='properties[Cutline]']"
          );
          if (cutlineTextarea) {
            cutlineTextarea.value = selectedVariant.dataset.shape;
          }
        }

        if (shapeArtwork) {
          shapeArtwork.textContent = selectedVariant.dataset.shape;
        }
      }
    });
  }

  // **Event Listener: Material Selection**
  function setupMaterialSelection() {
    document.addEventListener("click", function (event) {
      const selectedMaterial = event.target.closest(
        "#material-variant .pcs-mat-card"
      );

      if (selectedMaterial) {
        document.querySelectorAll("#material-variant .pcs-mat-card").forEach((el) => {
          el.classList.remove("pcs-mat-card--selected");
          el.setAttribute("aria-selected", "false");
        });

        selectedMaterial.classList.add("pcs-mat-card--selected");
        selectedMaterial.setAttribute("aria-selected", "true");

        const matVal = selectedMaterial.dataset.material;
        const hiddenMat = document.getElementById("selected-material");
        if (hiddenMat) hiddenMat.value = matVal;

        const calculator = document.querySelector("#calculator");
        if (calculator) {
          const matSelect = calculator.querySelector(
            "select[name='properties[Material]']"
          );
          if (matSelect) matSelect.value = matVal;
          const matInput = calculator.querySelector(
            "input[name='properties[Material]']"
          );
          if (matInput) matInput.value = matVal;
        }

        updateCalculator();
        safePriceUpdation();
      }
    });
  }

  // **Event Listener: Size Selection**
  function setupSizeSelection() {
    const sizeSelect = document.getElementById("size-select");
    const customWidth = document.getElementById("custom-width");
    const customHeight = document.getElementById("custom-height");
    const customSizeWrapper = document.getElementById("custom-size-input");
    const sizeErrorBar = document.getElementById("size-error-bar");

    [customWidth, customHeight].forEach((input) => {
      input.addEventListener("input", function () {
        // Mark "custom" as selected
        sizeSelect.classList.remove("variant-picked");
        sizeSelect.value = "custom";

        // Update state
        state.width = customWidth.value ? parseFloat(customWidth.value) : null;
        state.height = customHeight.value
          ? parseFloat(customHeight.value)
          : null;
        state.greater_dimension = greaterDimension(
          state.width || 0,
          state.height || 0
        );
        updateCalculator();

        // Remove error-field for the current input if it has a value
        if (input.value.trim() !== "") {
          input.classList.remove("error-field");
        }

        // Show or hide sizeErrorBar and customSizeWrapper based on both inputs
        if (
          customWidth.value.trim() !== "" &&
          customHeight.value.trim() !== ""
        ) {
          customSizeWrapper.classList.add("variant-picked");
          sizeErrorBar.classList.remove("active");
        } else {
          customSizeWrapper.classList.remove("variant-picked");
        }
      });
    });

    sizeSelect.addEventListener("change", function () {
      const sizeErrorBar = document.getElementById("size-error-bar");
      if (this.value !== "custom") {
        this.classList.add("variant-picked");
        customSizeWrapper.classList.remove("variant-picked");
        customWidth.classList.remove("error-field");
        customHeight.classList.remove("error-field");
        sizeErrorBar.classList.remove("active");

        customWidth.value = "";
        customHeight.value = "";
        [state.width, state.height] = this.value
          .split(" x ")
          .map((dim) => parseFloat(dim.replace('"', "")));
        state.greater_dimension = greaterDimension(state.width, state.height);
        updateCalculator();
      } else {
        this.classList.remove("variant-picked");
      }
    });
  }

  // **Event Listener: Quantity Selection (tier radios + custom field)**
  function setupQuantitySelection() {
    const tierList = document.getElementById("pcs-quantity-tier-list");
    const customQuantityInput = document.getElementById("custom-quantity");
    const customQuantityWrapper = document.getElementById(
      "custom-quantity-input"
    );
    const quantityErrorBar = document.getElementById("quantity-error-bar");
    const qtyHidden = document.getElementById("pcs-quantity-hidden");

    if (tierList) {
      tierList.addEventListener("change", (e) => {
        const t = e.target;
        if (t.name !== "quantity-tier") return;
        if (t.value === "custom") {
          customQuantityWrapper?.classList.remove("variant-picked");
          if (!customQuantityInput?.value?.trim()) {
            state.quantity_variable = null;
            if (qtyHidden) qtyHidden.value = "";
          } else {
            state.quantity_variable = parseInt(customQuantityInput.value, 10);
            if (qtyHidden) qtyHidden.value = String(state.quantity_variable);
          }
          updateCalculator();
          pcsSyncQuantityTierSelectedClasses();
          requestAnimationFrame(() => customQuantityInput?.focus());
          return;
        }
        customQuantityInput.value = "";
        customQuantityWrapper?.classList.remove("variant-picked");
        customQuantityInput?.classList.remove("error-field");
        quantityErrorBar?.classList.remove("active");
        state.quantity_variable = parseInt(t.value, 10);
        if (qtyHidden) qtyHidden.value = String(state.quantity_variable);
        updateCalculator();
        pcsSyncQuantityTierSelectedClasses();
      });

      tierList.addEventListener("click", (e) => {
        const customTier = e.target.closest(".pcs-qty-tier--custom");
        if (!customTier || !tierList.contains(customTier)) return;
        requestAnimationFrame(() => customQuantityInput?.focus());
      });
    }

    customQuantityInput.addEventListener("input", function () {
      const customRadio = document.querySelector(
        'input[name="quantity-tier"][value="custom"]'
      );
      if (customRadio) {
        customRadio.checked = true;
        tierList
          ?.querySelectorAll('input[name="quantity-tier"]')
          .forEach((r) => {
            if (r !== customRadio) r.checked = false;
          });
        pcsSyncQuantityTierSelectedClasses();
      }

      state.quantity_variable =
        customQuantityInput.value.trim() !== ""
          ? parseInt(customQuantityInput.value, 10)
          : null;
      if (qtyHidden && state.quantity_variable != null) {
        qtyHidden.value = String(state.quantity_variable);
      }
      updateCalculator();

      if (customQuantityInput.value.trim() !== "") {
        customQuantityWrapper.classList.add("variant-picked");
        customQuantityInput.classList.remove("error-field");
        quantityErrorBar.classList.remove("active");
      } else {
        customQuantityWrapper.classList.remove("variant-picked");
      }
    });
  }

  function uploadArtwork() {
    // **Get necessary elements**
    const uploadArtworkBtn = document.getElementById("upload-artwork-btn");
    const uploadArtworkSection = document.getElementById("upload-artwork");
    const customFieldsSection = document.getElementById("pcs-custom-fields");
    const backToEditorBtn = document.getElementById("back-to-editor");
    const chooseFileBtn = document.getElementById("choose-file-btn");
    const fileInput = document.querySelector(".calc-prop.cpc-file-upload");
    const filePath = document.getElementById("file-path");
    const filePathDisplay = document.querySelector("#file-path p");
    const designProofCheckbox = document.getElementById(
      "design-proof-checkbox"
    );
    const designProof = document.getElementById("design-proof");
    const fileInstructionsBox = document.getElementById(
      "file-instructions-box"
    );
    const fileInstructionsInput = document.getElementById("file-instructions");
    const pcs_add_to_cart = document.getElementById("pcs-add-to-cart");
    const product_loader = document.getElementById("product_loader");
    const uploadFileBox = document.querySelector(".upload-file-box");
    const laterOption = document.querySelector(".later-option");
    const emailLaterCheckbox = document.getElementById("email-later");
    const instructionsBox = document.getElementById("instructions-box");
    const instructionsInput = document.getElementById("instructions");

    const sizeSelect = document.getElementById("size-select");
    const customTierRadio = document.querySelector(
      'input[name="quantity-tier"][value="custom"]'
    );
    const customWidth = document.getElementById("custom-width");
    const customHeight = document.getElementById("custom-height");
    const customQuantityInput = document.getElementById("custom-quantity");
    const sizeErrorBar = document.getElementById("size-error-bar");
    const quantityErrorBar = document.getElementById("quantity-error-bar");
    const calculator = document.getElementById("calculator");

    // **Function to validate custom fields**
    function validateCustomFields() {
      let firstEmptyField = null;

      // Reset previous error highlights
      [customWidth, customHeight, customQuantityInput].forEach((field) => {
        field.classList.remove("error-field");
        sizeErrorBar.classList.remove("active");
        quantityErrorBar.classList.remove("active");
      });

      // If Custom Size is selected, check width & height fields
      if (sizeSelect.value === "custom") {
        if (!customWidth.value.trim()) {
          customWidth.classList.add("error-field");
          sizeErrorBar.classList.add("active");
          firstEmptyField = firstEmptyField || customWidth;
        }
        if (!customHeight.value.trim()) {
          customHeight.classList.add("error-field");
          sizeErrorBar.classList.add("active");
          firstEmptyField = firstEmptyField || customHeight;
        }
      }

      // If Custom Quantity tier is selected, check quantity field
      if (customTierRadio?.checked) {
        if (!customQuantityInput.value.trim()) {
          customQuantityInput.classList.add("error-field");
          quantityErrorBar.classList.add("active");
          firstEmptyField = firstEmptyField || customQuantityInput;
        }
      }

      // If any required field is empty, scroll to it and return false
      if (firstEmptyField) {
        const fieldRect = firstEmptyField.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const scrollY =
          window.scrollY +
          fieldRect.top -
          (windowHeight - fieldRect.height) / 2;

        window.scrollTo({ top: scrollY, behavior: "smooth" });
        return false;
      }

      return true;
    }

    // **Function to toggle visibility with smooth transition**
    function toggleVisibility(showElement, hideElement) {
      if (hideElement) {
        hideElement.style.opacity = "0";
        setTimeout(() => {
          hideElement.style.display = "none";
          if (showElement) {
            showElement.style.display = "block";
            setTimeout(() => {
              showElement.style.opacity = "1";
            }, 50);
          }
        }, 300);
      }
    }

    // **Show Upload Artwork Section**
    if (uploadArtworkBtn) {
      uploadArtworkBtn.addEventListener("click", () => {
        if (!validateCustomFields()) return;

        const artworkBox = document.querySelector(".artwork-box");
        window.scrollTo({ top: 0, behavior: "smooth" });
        toggleVisibility(uploadArtworkSection, customFieldsSection);

        setTimeout(() => {
          if (artworkBox) {
            const boxRect = artworkBox.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const scrollY =
              window.scrollY +
              boxRect.top -
              (windowHeight - boxRect.height) / 2;

            window.scrollTo({ top: scrollY, behavior: "smooth" });
          }
        }, 300); // Delay to ensure visibility transition

        // Blink border utility
        function blinkElement(
          element,
          className = "blink-border",
          blinks = 4,
          interval = 200
        ) {
          if (!element) return;

          for (let i = 0; i < blinks * 2; i++) {
            setTimeout(() => {
              element.classList.toggle(className);
            }, i * interval);
          }
        }

        // Usage
        blinkElement(artworkBox);
      });
    }

    // **Back to Editor Functionality**
    if (backToEditorBtn) {
      backToEditorBtn.addEventListener("click", () => {
        toggleVisibility(customFieldsSection, uploadArtworkSection);
      });
    }

    function updateButtonState() {
      // Disable Add to Cart button if neither option is selected
      if (!fileInput.files.length && !emailLaterCheckbox.checked) {
        pcs_add_to_cart.disabled = true;
      } else {
        pcs_add_to_cart.disabled = false;
        setTimeout((e) => {
          pcs_add_to_cart.classList.add("shine");
        }, 1000);
        setTimeout((e) => {
          pcs_add_to_cart.classList.remove("shine");
        }, 2000);
      }
      updateCheckoutOrderSummary();
      placeCheckoutButton(artworkHasUploadedFile());
      placeCheckoutSummary();
    }

    // **Trigger File Input Dialog**
    if (chooseFileBtn && fileInput) {
      chooseFileBtn.addEventListener("click", () => {
        fileInput.click();
      });

      // **Update File Name in UI**
      fileInput.addEventListener("change", (event) => {
        if (event.target.files.length > 0) {
          filePath.style.display = "block";
          laterOption.classList.add("dim--block");
          uploadFileBox.classList.remove("dim--block");
          designProofCheckbox.style.display = "flex";
          fileInstructionsBox.classList.add("active");
          const file = event.target.files[0];
          if (file) {
            const fullName = file.name;
            if (fullName.length > 30) {
              const start = fullName.slice(0, 8);
              const end = fullName.slice(-9); // You can adjust this
              filePathDisplay.textContent = `${start}....${end}`;
            } else {
              filePathDisplay.textContent = fullName;
            }
          }

          emailLaterCheckbox.checked = false;
          instructionsBox.classList.remove("active");
          if (calculator) {
            calculator.querySelector(
              "textarea[name='properties[No Image]']"
            ).value = null;
          }
        } else {
          filePath.style.display = "none";
          designProofCheckbox.style.display = "none";
          fileInstructionsBox.classList.remove("active");
        }

        updateButtonState();

        //   if (window.innerWidth <= 768 && pcs_add_to_cart) {
        //     setTimeout(() => {
        //       const rect = pcs_add_to_cart.getBoundingClientRect();
        //       const scrollY =
        //         window.scrollY +
        //         rect.top -
        //         (window.innerHeight - rect.height) / 2;
        //       window.scrollTo({ top: scrollY, behavior: "smooth" });
        //     }, 300);
        //   }
      });
    }

    designProof.addEventListener("change", (e) => {
      if (calculator) {
        calculator.querySelector(
          "input.checkbox[name='properties[Design Proof Before Shipping ]']"
        ).checked = e.target.checked;
      }
    });

    if (instructionsInput && calculator) {
      instructionsInput.addEventListener("input", function () {
        calculator.querySelector(
          "textarea[name='properties[Instructions]']"
        ).value = instructionsInput.value;

        fileInstructionsInput.value = instructionsInput.value;
      });
    }

    if (fileInstructionsInput && calculator) {
      fileInstructionsInput.addEventListener("input", function () {
        calculator.querySelector(
          "textarea[name='properties[Instructions]']"
        ).value = fileInstructionsInput.value;

        instructionsInput.value = fileInstructionsInput.value;
      });
    }

    emailLaterCheckbox.addEventListener("change", function () {
      if (emailLaterCheckbox.checked) {
        // Reset the uploaded file
        fileInput.value = "";
        filePath.style.display = "none";
        laterOption.classList.remove("dim--block");
        uploadFileBox.classList.add("dim--block");
        designProofCheckbox.style.display = "none";
        fileInstructionsBox.classList.remove("active");
        instructionsBox.classList.add("active");

        if (calculator) {
          calculator.querySelector(
            "textarea[name='properties[No Image]']"
          ).value = "Request an image from the client.";
        }
      } else {
        instructionsBox.classList.remove("active");

        laterOption.classList.add("dim--block");
        uploadFileBox.classList.remove("dim--block");

        if (calculator) {
          calculator.querySelector(
            "textarea[name='properties[No Image]']"
          ).value = null;
        }
      }
      updateButtonState();
    });

    // pcs_add_to_cart.addEventListener("click", (e) => {
    //   pcs_add_to_cart.classList.add("loading");
    //   pcs_add_to_cart.disabled = true;
    //   pcs_add_to_cart.innerHTML = `Adding to Cart <div class="dot-falling"></div>`;
    //   document.getElementById("AddToCart").click();
    // });

    updateButtonState();
  }

  // **Mutation Observer to watch for calculator form loading**
  const observer = new MutationObserver(() => {
    if (document.querySelector("#calculator")) {
      observer.disconnect();
      document.getElementById("product_loader").classList.remove("loading");
      document.querySelector(".loading-variants__list")?.classList.remove("loading-variants__list");
      setupShapeSelection();
      pcsApplyMaterialPickerSwatches();
      setupMaterialSelection();
      setupSizeSelection();
      setupQuantitySelection();
      updateCalculator();
      uploadArtwork();
      setupApippaAddToCart();
      setupUpsellTriggers();
      renderUpsellCards(); // Pre-render but hidden until file is uploaded
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  if (document.getElementById("material-variant")) {
    pcsApplyMaterialPickerSwatches();
  }

  //--###MINI CART FUNCTIONALITY--###//
  function typeText(el, text, speed = 60) {
    return new Promise((resolve) => {
      let i = 0;
      const typeInterval = setInterval(() => {
        el.textContent += text[i];
        i++;
        if (i >= text.length) {
          clearInterval(typeInterval);
          resolve();
        }
      }, speed);
    });
  }

  function deleteText(el, speed = 40) {
    return new Promise((resolve) => {
      const delInterval = setInterval(() => {
        el.textContent = el.textContent.slice(0, -1);
        if (el.textContent.length === 0) {
          clearInterval(delInterval);
          resolve();
        }
      }, speed);
    });
  }

  function resetCalculatorForm() {
    const form = document.querySelector("#calculator");
    if (!form) return;

    // Reset all inputs
    form.querySelectorAll("input, select, textarea").forEach((input) => {
      if (input.type === "checkbox" || input.type === "radio") {
        input.checked = false;
      } else {
        input.value = "";
      }
    });

    // ======================
    // Default Shape: Diecut
    // ======================
    document
      .querySelectorAll(".sticker-variant[data-shape]")
      .forEach((el) => el.classList.remove("active"));
    const defaultShape = document.querySelector(
      ".sticker-variant[data-shape='Diecut']"
    );
    if (defaultShape) defaultShape.classList.add("active");
    const shapeInput = document.getElementById("selected-shape");
    if (shapeInput) shapeInput.value = "Diecut";

    // ======================
    // Default Size: 3" x 3"
    // ======================
    const sizeSelect = document.getElementById("size-select");
    if (sizeSelect) {
      for (const option of sizeSelect.options) {
        if (option.textContent.trim() === '3" x 3"') {
          sizeSelect.value = option.value;
          sizeSelect.dispatchEvent(new Event("change"));
          break;
        }
      }
    }

    document.getElementById("custom-width").value = "";
    document.getElementById("custom-height").value = "";
    document
      .getElementById("custom-size-input")
      .classList.remove("variant-picked");

    // ======================
    // Default Quantity: 100 pcs
    // ======================
    document.getElementById("custom-quantity").value = "";
    const qtyHiddenReset = document.getElementById("pcs-quantity-hidden");
    if (qtyHiddenReset) qtyHiddenReset.value = "100";
    state.quantity_variable = 100;
    const r100 = document.querySelector(
      'input[name="quantity-tier"][value="100"]'
    );
    if (r100) {
      r100.checked = true;
      document
        .querySelectorAll('input[name="quantity-tier"]')
        .forEach((r) => {
          if (r !== r100) r.checked = false;
        });
      pcsSyncQuantityTierSelectedClasses();
    } else {
      pcsTryInitQuantityTiers();
    }
    document
      .querySelector(".quantity-price-box")
      ?.classList.add("variant-picked");

    // ======================
    // Default Material: Vinyl Stickers
    // ======================
    document.querySelectorAll("#material-variant .pcs-mat-card").forEach((el) => {
      el.classList.remove("pcs-mat-card--selected");
      el.setAttribute("aria-selected", "false");
    });
    const defaultMaterial = document.querySelector(
      "#material-variant .pcs-mat-card[data-material='Vinyl Stickers']"
    );
    if (defaultMaterial) {
      defaultMaterial.classList.add("pcs-mat-card--selected");
      defaultMaterial.setAttribute("aria-selected", "true");
    }
    const materialInput = document.getElementById("selected-material");
    if (materialInput) materialInput.value = "Vinyl Stickers";

    // ======================
    // Clear UI & File fields
    // ======================
    document.getElementById("file-path")?.style.setProperty("display", "none");
    const fileNameDisplay = document.querySelector("#file-path p");
    if (fileNameDisplay) fileNameDisplay.textContent = "";
    document.querySelector(".calc-prop.cpc-file-upload").value = "";
    document.getElementById("email-later").checked = false;
    document.getElementById("design-proof").checked = false;
    document.getElementById("file-instructions").value = "";
    document.getElementById("instructions").value = "";

    // UI Reset
    document.querySelector(".later-option")?.classList.add("dim--block");
    document.querySelector(".upload-file-box")?.classList.remove("dim--block");
    document
      .getElementById("file-instructions-box")
      ?.classList.remove("active");
    document.getElementById("instructions-box")?.classList.remove("active");
    document
      .getElementById("design-proof-checkbox")
      ?.style.setProperty("display", "none");
    document.getElementById("pcs-add-to-cart").disabled = true;

    // Hide Errors
    document.getElementById("size-error-bar")?.classList.remove("active");
    document.getElementById("quantity-error-bar")?.classList.remove("active");

    // Reset prices
    document.getElementById("pcs-final-price").textContent = "0.00";
    document.getElementById("pcs-cutoff-price").textContent = "0.00";

    // Reset artwork preview
    document.getElementById("shape-artwork").textContent = "Diecut";
    document.getElementById("width-artwork").textContent = "3";
    document.getElementById("height-artwork").textContent = "3";
    document.getElementById("quantity-artwork").textContent = "100";

    // Update hidden form inputs
    form.querySelector("input[name='properties[Width]']").value = "3";
    form.querySelector("input[name='properties[Height]']").value = "3";
    form.querySelector("input[name='properties[Quantity]']").value = "100";
    form.querySelector("textarea[name='properties[Cutline]']").value = "Diecut";
    const resetMatSelect = form.querySelector(
      "select[name='properties[Material]']"
    );
    if (resetMatSelect) resetMatSelect.value = "Vinyl Stickers";
    const resetMatInput = form.querySelector(
      "input[name='properties[Material]']"
    );
    if (resetMatInput) resetMatInput.value = "Vinyl Stickers";

    const discountInput = form.querySelector(
      "input[name='properties[Discount]']"
    );
    if (discountInput) discountInput.value = "";

    // Optional JS state update
    if (typeof state !== "undefined") {
      state.quantity_variable = 100;
      state.width = 3;
      state.height = 3;
      state.greater_dimension = 3;
    }

    // Re-run pricing logic
    if (typeof updateCalculator === "function") {
      updateCalculator();
    }

    console.log(
      "Reset complete → Default size: 3x3, Qty: 100, Material: Print Custom Sticker"
    );
  }

  // ========== Checkout progress overlay (stickers only): Apippa + cart ==========
  let pcsCheckoutTitleCycleActive = false;

  function pcsStopCheckoutProgressTitleCycle() {
    pcsCheckoutTitleCycleActive = false;
  }

  async function pcsRunCheckoutProgressTitleCycle() {
    const titleEl = document.getElementById("pcs-checkout-progress-title");
    if (!titleEl) return;
    const messages = [
      "Updating your cart…",
      "Hold on tight…",
      "Don't Close the browser…",
    ];
    const pauseAfterTypeMs = 3400;
    const charDelayMs = 40;
    let idx = 0;
    while (pcsCheckoutTitleCycleActive) {
      const msg = messages[idx % messages.length];
      titleEl.classList.add("pcs-checkout-progress-title--typing");
      titleEl.textContent = "";
      for (let i = 0; i < msg.length; i++) {
        if (!pcsCheckoutTitleCycleActive) {
          titleEl.classList.remove("pcs-checkout-progress-title--typing");
          return;
        }
        titleEl.textContent += msg[i];
        await new Promise((r) => setTimeout(r, charDelayMs));
      }
      let waited = 0;
      const tick = 80;
      while (waited < pauseAfterTypeMs && pcsCheckoutTitleCycleActive) {
        await new Promise((r) => setTimeout(r, tick));
        waited += tick;
      }
      idx++;
    }
    titleEl.classList.remove("pcs-checkout-progress-title--typing");
  }

  function pcsStartCheckoutProgressTitleCycle() {
    pcsCheckoutTitleCycleActive = false;
    const titleEl = document.getElementById("pcs-checkout-progress-title");
    if (titleEl) {
      titleEl.classList.remove("pcs-checkout-progress-title--typing");
    }
    pcsCheckoutTitleCycleActive = true;
    pcsRunCheckoutProgressTitleCycle();
  }

  function pcsOpenCheckoutProgress() {
    const root = document.getElementById("pcs-checkout-progress-overlay");
    if (!root) return;
    if (root.parentElement !== document.body) {
      document.body.appendChild(root);
    }
    root.hidden = false;
    root.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    pcsStartCheckoutProgressTitleCycle();
    const logo = document.getElementById("pcs-checkout-progress-logo");
    if (logo) {
      const isIOS =
        /iP(hone|ad|od)/i.test(navigator.userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
      const raw = logo.getAttribute("src") || logo.src || "";
      const base = raw.split("?")[0];
      if (isIOS && base && /\.gif$/i.test(base)) {
        logo.src = base + "?pcl=" + Date.now();
      }
    }
  }

  function pcsCloseCheckoutProgress() {
    pcsStopCheckoutProgressTitleCycle();
    const root = document.getElementById("pcs-checkout-progress-overlay");
    if (!root) return;
    root.hidden = true;
    root.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    const bar = document.getElementById("pcs-checkout-progress-bar");
    if (bar) bar.style.width = "0%";
    const steps = document.getElementById("pcs-checkout-progress-steps");
    if (steps) steps.innerHTML = "";
    const status = document.getElementById("pcs-checkout-progress-status");
    if (status) status.textContent = "";
    const titleEl = document.getElementById("pcs-checkout-progress-title");
    if (titleEl) {
      titleEl.textContent = "Updating your cart…";
      titleEl.classList.remove("pcs-checkout-progress-title--typing");
    }
  }

  function pcsEscapeCheckoutLabel(str) {
    if (str == null) return "";
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function pcsRenderCheckoutStepRows(step, totalSteps, mainLabel) {
    const list = document.getElementById("pcs-checkout-progress-steps");
    if (!list) return;

    const upsells = Array.isArray(upsellCart) ? upsellCart : [];
    const onRefresh = totalSteps > 0 && step >= totalSteps;

    let primaryState = "pending";
    if (step === 0) primaryState = "pending";
    else if (onRefresh || step >= 3) primaryState = "complete";
    else if (step >= 1) primaryState = "active";

    const rows = [{ label: mainLabel || "Main sticker", state: primaryState }];

    for (let j = 0; j < upsells.length; j++) {
      const u = upsells[j];
      const label =
        u.displayName || pcsMaterialShortName(u.material) || "Add-on";
      let uState = "pending";
      const start = 3 + 2 * j;
      if (!onRefresh && step >= start && step <= start + 1) uState = "active";
      else if (step > start + 1) uState = "complete";
      rows.push({ label, state: uState });
    }

    list.innerHTML = rows
      .map((r) => {
        let meta =
          '<span class="pcs-step-icon-slot" aria-hidden="true"></span>';
        if (r.state === "complete") {
          meta =
            '<span class="pcs-step-icon pcs-step-icon--check" aria-hidden="true">\u2713</span>';
        } else if (r.state === "active") {
          meta =
            '<span class="pcs-step-indicator-active"><span class="pcs-step-arrow" aria-hidden="true">\u2192</span><span class="pcs-step-spinner" role="status" aria-label="Loading"></span></span>';
        }
        return `<li class="pcs-checkout-progress-step pcs-step--${r.state}"><span class="pcs-checkout-progress-step-label">${pcsEscapeCheckoutLabel(r.label)}</span><span class="pcs-checkout-progress-step-meta">${meta}</span></li>`;
      })
      .join("");
  }

  function pcsSetCheckoutProgressUI(
    step,
    totalSteps,
    phase,
    detail,
    mainLabel
  ) {
    const barEl = document.getElementById("pcs-checkout-progress-bar");
    const statusEl = document.getElementById("pcs-checkout-progress-status");
    const pct =
      totalSteps > 0 ? Math.min(100, Math.round((step / totalSteps) * 100)) : 0;
    if (barEl) barEl.style.width = pct + "%";
    const statusLine = [phase, detail].filter(Boolean).join(" \u2014 ");
    if (statusEl) statusEl.textContent = statusLine;
    pcsRenderCheckoutStepRows(step, totalSteps, mainLabel);
  }

  function pcsMaterialShortName(materialKey) {
    if (!materialKey) return "your sticker";
    return (
      UPSELL_MATERIAL_DISPLAY_NAMES[materialKey] ||
      materialKey.replace(/\s+Stickers$/i, "").trim() ||
      materialKey
    );
  }

  function setupApippaAddToCart() {
    const addToCartBtn = document.getElementById("pcs-add-to-cart");
    if (!addToCartBtn) return;

    addToCartBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      let buttonLoaderInterval = null;
      let addToCartSucceeded = false;
      addToCartBtn.classList.remove("is-atc-success");
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add("loading");
      addToCartBtn.innerHTML = `
          <div class="pcs-loader"></div>
          <p class="pcs-message"></p>
          <div class="dot-falling"></div>
        `;

      const messageEl = addToCartBtn.querySelector(".pcs-message");

      // Looping text messages
      const messages = ["Adding to cart", "GETTING THINGS READY"];
      let messageIndex = 0;
      let stopTypingLoop = false;

      const startTypingLoop = async () => {
        while (!stopTypingLoop) {
          const message = messages[messageIndex % messages.length];
          await typeText(messageEl, message);
          await new Promise((resolve) => setTimeout(resolve, 2000));
          await deleteText(messageEl);
          messageIndex++;
        }
      };

      startTypingLoop();

      const loadingBar = addToCartBtn.querySelector(".pcs-loader");

      let progress = 0;
      const target = 99;

      buttonLoaderInterval = setInterval(() => {
        if (progress < 50) {
          progress += 2;
        } else if (progress < 80) {
          progress += (80 - progress) * 0.05;
        } else if (progress < target - 0.2) {
          progress += (target - progress) * 0.05;
        } else {
          progress = target - 0.01;
          clearInterval(buttonLoaderInterval);
          buttonLoaderInterval = null;
        }

        if (loadingBar) {
          loadingBar.style.transform = `scaleX(${Math.floor(progress)}%)`;
        }
      }, 80);

      const productId = document.querySelector(
        "input[name='product-id']"
      ).value;
      const calculatorId = document
        .getElementById("calculator")
        .getAttribute("data-calcid");
      const form = document.querySelector("#calculator");

      if (!form) {
        alert("Calculator form not found.");
        stopTypingLoop = true;
        if (buttonLoaderInterval) clearInterval(buttonLoaderInterval);
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove("loading");
        addToCartBtn.innerHTML = "Add to cart";
        pcsCloseCheckoutProgress();
        return;
      }

      // Prepare properties object for PRIMARY item
      const properties = {};
      const inputs = form.querySelectorAll("[name^='properties']");
      let fileInput = form.querySelector("input[type='file']");
      let fileToUpload = null;

      inputs.forEach((input) => {
        const name = input.name.replace("properties[", "").replace("]", "");
        if (input.type === "checkbox") {
          properties[name] = input.checked ? "Checked" : "Unchecked";
        } else if (input.type !== "file") {
          properties[name] = input.value;
        }
      });

      if (fileInput && fileInput.files.length > 0) {
        fileToUpload = fileInput.files[0];
      }

      /* Sticker count for Apippa (variant is priced as the full job total for that count).
         Shopify line item quantity must stay 1: variant price is already the full $68.11-style
         total, not per-sticker — otherwise cart multiplies price × qty (e.g. ×100 → $6811). */
      const rawPrimaryQty =
        state.quantity_variable != null && state.quantity_variable !== ""
          ? Number(state.quantity_variable)
          : parseInt(String(properties["Quantity"] || "1"), 10);
      const primaryStickerCount = Math.max(
        1,
        Math.floor(
          Number.isFinite(rawPrimaryQty) && rawPrimaryQty > 0
            ? rawPrimaryQty
            : 1
        )
      );
      properties["Quantity"] = String(primaryStickerCount);

      const requestData = {
        calculatorId,
        productId,
        properties,
      };

      const upsellN = upsellCart.length;
      const totalProgressSteps = 2 + upsellN * 2 + 1;
      let progressStep = 0;
      const mainMatLabel = pcsMaterialShortName(properties["Material"]);
      const bumpProgress = (phase, detail) => {
        progressStep = Math.min(progressStep + 1, totalProgressSteps);
        pcsSetCheckoutProgressUI(
          progressStep,
          totalProgressSteps,
          phase,
          detail,
          mainMatLabel
        );
      };

      try {
        pcsOpenCheckoutProgress();
        pcsSetCheckoutProgressUI(
          0,
          totalProgressSteps,
          "Preparing your order",
          upsellN === 0
            ? "Building your main custom sticker, then adding it to the cart."
            : `Main sticker plus ${upsellN} material add-on${upsellN === 1 ? "" : "s"} — each is priced and added in order.`,
          mainMatLabel
        );

        console.log("Apippa API Sent — Primary Item");

        // ====== ADD PRIMARY ITEM ======
        bumpProgress(
          "Main sticker",
          `Creating your custom price for ${mainMatLabel}…`
        );
        const variantRes = await fetch(
          "https://api.custompricecalculator.com/api/v1/variant",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(requestData),
          }
        );

        const variantId = await variantRes.json();
        const shopifyVariantId =
          typeof variantId === "string"
            ? variantId
            : variantId?.variantId || variantId?.id;

        if (!shopifyVariantId) throw new Error("Invalid variant ID");

        const formData = new FormData();
        formData.append("id", shopifyVariantId);
        formData.append("quantity", "1");

        Object.keys(properties).forEach((key) => {
          formData.append(`properties[${key}]`, properties[key]);
        });

        if (fileToUpload) {
          formData.append(`properties[Upload Image]`, fileToUpload);
        }

        bumpProgress(
          "Main sticker",
          `Adding ${mainMatLabel} to your cart…`
        );
        const cartAddRes = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        });

        const cartAddJson = await cartAddRes.json();
        console.log("Primary Add to Cart Response:", cartAddJson);

        localStorage.setItem(
          `patched-cart-item-${cartAddJson.id}`,
          JSON.stringify({
            id: cartAddJson.id,
            title: cartAddJson.product_title,
            image: cartAddJson.image,
            price: cartAddJson.price,
          })
        );

        if (!cartAddRes.ok) throw new Error("Failed to add primary item to cart");

        const primaryCartItemKey = cartAddJson.key;

        // ====== ADD UPSELL ITEMS ======
        for (let ui = 0; ui < upsellCart.length; ui++) {
          const upsellItem = upsellCart[ui];
          const displayMat = pcsMaterialShortName(upsellItem.material);
          const remainingAfter = upsellCart.length - ui - 1;
          const remainingSuffix =
            remainingAfter > 0
              ? ` ${remainingAfter} add-on${remainingAfter === 1 ? "" : "s"} remain after this.`
              : "";

          console.log(`Apippa API Sent — Upsell: ${upsellItem.material}`);

          bumpProgress(
            `Material add-on ${ui + 1} of ${upsellCart.length}`,
            `Creating price for ${displayMat}…${remainingSuffix}`
          );

          const upsellProperties = { ...properties };

          upsellProperties["Material"] = upsellItem.material;

          upsellProperties["Quantity"] = upsellItem.quantity.toString();

          const adjustedQty = calculateDiscount(upsellItem.quantity);
          const greaterDim = state.greater_dimension;
          const bulkDiscount =
            state.discounts?.[upsellItem.material]?.[greaterDim]?.[adjustedQty] ?? 0;
          const bulkMultiplier = (100 - bulkDiscount) / 100;

          const upsellMultiplier =
            bulkMultiplier * ((100 - UPSELL_DISCOUNT_PERCENT) / 100);
          upsellProperties["Discount"] = upsellMultiplier.toString();

          upsellProperties["_Upsell Add-on"] = "Yes";
          upsellProperties["_Upsell Discount"] = `${UPSELL_DISCOUNT_PERCENT}%`;
          upsellProperties["_Primary Order Ref"] = primaryCartItemKey.toString();

          const upsellRequestData = {
            calculatorId,
            productId,
            properties: upsellProperties,
          };

          const upsellVariantRes = await fetch(
            "https://api.custompricecalculator.com/api/v1/variant",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify(upsellRequestData),
            }
          );

          const upsellVariantData = await upsellVariantRes.json();
          const upsellShopifyVariantId =
            typeof upsellVariantData === "string"
              ? upsellVariantData
              : upsellVariantData?.variantId || upsellVariantData?.id;

          if (!upsellShopifyVariantId) {
            console.error("Failed to create upsell variant for:", upsellItem.material);
            bumpProgress(
              `Material add-on ${ui + 1} of ${upsellCart.length}`,
              `Could not create a price for ${displayMat} — skipping this add-on.`
            );
            continue;
          }

          const upsellFormData = new FormData();
          upsellFormData.append("id", upsellShopifyVariantId);
          upsellFormData.append("quantity", "1");

          Object.keys(upsellProperties).forEach((key) => {
            upsellFormData.append(`properties[${key}]`, upsellProperties[key]);
          });

          if (fileToUpload) {
            upsellFormData.append(`properties[Upload Image]`, fileToUpload);
          }

          bumpProgress(
            `Material add-on ${ui + 1} of ${upsellCart.length}`,
            `Adding ${displayMat} to your cart…`
          );
          const upsellCartAddRes = await fetch("/cart/add.js", {
            method: "POST",
            body: upsellFormData,
          });

          const upsellCartAddJson = await upsellCartAddRes.json();
          console.log(
            `Upsell ${upsellItem.material} Add to Cart Response:`,
            upsellCartAddJson
          );

          localStorage.setItem(
            `patched-cart-item-${upsellCartAddJson.id}`,
            JSON.stringify({
              id: upsellCartAddJson.id,
              title: upsellCartAddJson.product_title,
              image: upsellCartAddJson.image,
              price: upsellCartAddJson.price,
            })
          );
        }

        // ====== REFRESH MINI CART (same as your existing logic) ======
        bumpProgress(
          "Almost there",
          "Refreshing your cart and opening the drawer…"
        );
        const cartJson_final = await fetch("/cart.js").then((res) => res.json());

        const timestamp = new Date().getTime();
        await new Promise((resolve) => setTimeout(resolve, 200));
        const sectionHtml = await fetch(
          `/cart?section_id=mini-cart&t=${timestamp}`
        ).then((res) => res.text());

        const fakeDiv = document.createElement("div");
        fakeDiv.innerHTML = sectionHtml;
        const miniCartHTML = fakeDiv.querySelector("cart-drawer")?.outerHTML;

        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer && miniCartHTML) {
          cartDrawer.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: {
                  ...cartJson_final,
                  sections: {
                    "mini-cart": miniCartHTML,
                  },
                },
                openMiniCart: true,
              },
            })
          );
        }

        // Price patching for mini cart (same logic but for all items)
        setTimeout(() => {
          const lineItems = cartDrawer?.querySelectorAll("line-item") || [];

          lineItems.forEach((lineItem) => {
            const desktopPriceContainer = lineItem.querySelector(
              ".line-item__price-list-container .price"
            );
            const mobilePriceContainer = lineItem.querySelector(
              ".product-item-meta__price-list-container .price-list.hidden-tablet-and-up .price"
            );

            if (!desktopPriceContainer && !mobilePriceContainer) return;

            const priceText = (
              desktopPriceContainer || mobilePriceContainer
            ).textContent.trim();
            const isFree = /Free|\$0\.00/.test(priceText);

            let lineVariantId;
            const productLink = lineItem.querySelector("a[href*='?variant=']");
            if (productLink?.href.includes("variant=")) {
              lineVariantId = productLink.href.split("variant=")[1].split("&")[0];
            }
            if (!lineVariantId) {
              const removeBtn = lineItem.querySelector(
                "a[href*='/cart/change?id=']"
              );
              const removeHref = removeBtn?.getAttribute("href") || "";
              const match = removeHref.match(/id=(\d+):/);
              lineVariantId = match?.[1];
            }

            if (isFree && lineVariantId) {
              const patchedData = localStorage.getItem(
                `patched-cart-item-${lineVariantId}`
              );
              if (patchedData) {
                const parsed = JSON.parse(patchedData);
                const correctPrice = (parsed.price / 100).toFixed(2);

                const updatedPriceHTML = `
                    <span class="visually-hidden">Sale price</span>
    
                    $${correctPrice}
                  `;
                if (desktopPriceContainer)
                  desktopPriceContainer.innerHTML = updatedPriceHTML;
                if (mobilePriceContainer)
                  mobilePriceContainer.innerHTML = updatedPriceHTML;
              }
            }
          });
        }, 300);

        setTimeout(async () => {
          const cartJsonCount = await fetch("/cart.js").then((res) => res.json());
          const cartCountEl = document.querySelector("cart-count");
          if (cartCountEl) {
            cartCountEl.textContent = cartJsonCount.item_count;
          }
        }, 300);

        // Confetti animation
        setTimeout(() => {
          const drawerContent = document.querySelector(
            "#shopify-section-mini-cart .drawer__content"
          );
          if (!drawerContent) return;

          const confetti = document.createElement("dotlottie-player");
          confetti.className = "mini-cart-lottie";
          confetti.src =
            "//cdn.shopify.com/s/files/1/0582/5400/0176/files/confetti.json?v=1748024242";
          confetti.setAttribute("background", "transparent");
          confetti.setAttribute("speed", "1");
          confetti.setAttribute("style", "width: 300px; height: 300px");
          confetti.setAttribute("direction", "1");
          confetti.setAttribute("playmode", "normal");
          confetti.setAttribute("autoplay", "");

          drawerContent.prepend(confetti);
          setTimeout(() => confetti.remove(), 3000);
        }, 1000);

        addToCartSucceeded = true;
      } catch (err) {
        console.error("Apippa Add to Cart Error:", err);
        alert("There was a problem adding your item to the cart.");
      } finally {
        stopTypingLoop = true;
        if (buttonLoaderInterval) {
          clearInterval(buttonLoaderInterval);
          buttonLoaderInterval = null;
        }
        pcsCloseCheckoutProgress();

        const finishAfterAdd = () => {
          addToCartBtn.classList.remove("is-atc-success");
          addToCartBtn.disabled = false;
          addToCartBtn.innerHTML = "Add to cart";
          upsellCart.length = 0;
          document.getElementById("back-to-editor").click();
          resetCalculatorForm();
          const upsellBlock = document.getElementById("upsell-block");
          if (upsellBlock) upsellBlock.style.display = "none";
        };

        if (addToCartSucceeded) {
          addToCartBtn.classList.remove("loading");
          addToCartBtn.classList.add("is-atc-success");
          addToCartBtn.disabled = false;
          addToCartBtn.innerHTML = "Added to cart";
          window.setTimeout(finishAfterAdd, 1400);
        } else {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove("loading");
          addToCartBtn.classList.remove("is-atc-success");
          addToCartBtn.innerHTML = "Add to cart";
          upsellCart.length = 0;
          document.getElementById("back-to-editor").click();
          resetCalculatorForm();
          const upsellBlock = document.getElementById("upsell-block");
          if (upsellBlock) upsellBlock.style.display = "none";
        }
      }
    });
  }


  // Sticky Upload Your Design Button
  const customizerSection = document.querySelector(
    ".shopify-section.shopify-section--main-product"
  );
  const vcStickyBar = document.getElementById("vc-sticky-bar");
  const stickyUploadDesignBtn = document.getElementById(
    "sticky-upload-design-btn"
  );
  const chatWidget = document.getElementById("chat-widget-container");
  const uploadArtworkBtn = document.getElementById("upload-artwork-btn");

  if (customizerSection) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            vcStickyBar.classList.remove("active");
            if (chatWidget) chatWidget.classList.remove("vc-sticky-bar-active");
          } else {
            vcStickyBar.classList.add("active");
            if (chatWidget) chatWidget.classList.add("vc-sticky-bar-active");
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "300px",
      }
    );

    observer.observe(customizerSection);
  }

  stickyUploadDesignBtn.addEventListener("click", (e) => {
    uploadArtworkBtn.click();
  });

  pcsStartQuantitySocialProofRotation();

  setInterval(() => {
    stickyUploadDesignBtn.classList.remove("shine");

    // Force reflow to restart the animation
    void stickyUploadDesignBtn.offsetWidth;

    stickyUploadDesignBtn.classList.add("shine");
  }, 5000);
});

// Handle Product Thumbnails with Materials
// document.addEventListener("DOMContentLoaded", function () {
//   const materialVariants = document.querySelectorAll(
//     ".material-variants__list .sticker-variant"
//   );
//   const thumbnailButtons = document.querySelectorAll(
//     ".product__thumbnail-list-inner .product__thumbnail-item"
//   );

//   materialVariants.forEach((variant, index) => {
//     variant.addEventListener("click", () => {
//       // Trigger click on corresponding thumbnail button
//       if (thumbnailButtons[index]) {
//         thumbnailButtons[index].click();
//       }
//       console.log(index)
//     });
//   });
// });
